import { CheckStyleKinds } from "../../../../../../base/domain/drawing";
import { IObjectNameIdentifier } from "../../../../../../documaker/domain/format/objects";
import { ICheckObject } from "../../../../../domain/editableFormat/objects";
import { ICheckObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { CheckableObjectTranslator } from "./base";
import { PatientProfileCheckKindTranslator, QuestionnaireTranslator, RelationReplacer } from "./properties";

export class CheckObjectTranslator extends AbstractObjectTranslator<ICheckObject, ICheckObjectBean> {
  constructor() {
    super(new CheckableObjectTranslator());
  }

  protected shouldRecordName(source: ICheckObjectBean): boolean {
    return true;
  }

  protected readName(source: ICheckObjectBean): IObjectNameIdentifier {
    return {
      key: source["@name"],
      subKey: source["@item-name"],
    };
  }

  overwriteObject(source: ICheckObject, bean: ICheckObjectBean, formatId: number): void {
    const on = (bean["@score-on"] !== undefined)
      ? this.integer.from(bean["@score-on"])
      : undefined;
    const isScoreOn = !!on && !isNaN(on);
    const off = (bean["@score-off"] !== undefined)
      ? this.integer.from(bean["@score-off"])
      : undefined;
    const isScoreOff = !!off && !isNaN(off);
    source.checkBehavior = {
      isChecked: (bean["@select"] === "1"),
      isMultiCheckable: (bean["@select-mode"] !== "1"),
      score: {
        on: isScoreOn ? on : 0,
        off: isScoreOff ? off : 0,
      },
      patientProfileKinds: this.patientProfileCheckKind.from(bean["@ptprofile-option"]),
      pastedTextToCheck: bean["@text"],
      isGroupScopePage: (bean["@group-scope"] !== "1"),
    };
    const kind = this.integer.from(bean["@check-type"]);
    source.checkStyle = {
      kind: (kind && !isNaN(kind)) ? kind : CheckStyleKinds.Check,
      paint: {
        isEnable: !!bean["@bg"],
        color: {
          value: this.colorCode.from(bean["@bg"]),
        },
      },
      border: {
        isEnable: (bean["@border"] !== "0"),
      },
    };
    source.questionnaire = this.questionnaire.from(bean);
  }

  overwriteBean(source: ICheckObjectBean, object: ICheckObject): void {
    source["@select"] = object.checkBehavior.isChecked ? "1" : "0";
    source["@select-mode"] = object.checkBehavior.isMultiCheckable ? undefined : "1";
    source["@score-on"] = object.checkBehavior.score.on !== 0 ? this.integer.to(object.checkBehavior.score.on) : undefined;
    source["@score-off"] = object.checkBehavior.score.off !== 0 ? this.integer.to(object.checkBehavior.score.off) : undefined;
    source["@ptprofile-option"] = this.patientProfileCheckKind.to(object.checkBehavior.patientProfileKinds);
    source["@text"] = object.checkBehavior.pastedTextToCheck;
    source["@group-scope"] = object.checkBehavior.isGroupScopePage ? undefined : "1";
    source["@check-type"] = (object.checkStyle.kind === CheckStyleKinds.Check) ? undefined : this.integer.to(object.checkStyle.kind);
    source["@bg"] = object.checkStyle.paint.isEnable
      ? this.colorCode.to(object.checkStyle.paint.color.value)
      : undefined;
    source["@border"] = object.checkStyle.border.isEnable ? undefined : "0";
    this.relationReplacer.replaceBeans(source, "questionnaire", this.questionnaire.to(object));
    this.relationReplacer.replaceBeans(source, "questionnaire-children", this.questionnaire.toChildren(object));
  }

  private readonly patientProfileCheckKind = new PatientProfileCheckKindTranslator();
  private readonly questionnaire = new QuestionnaireTranslator();
  private readonly relationReplacer = new RelationReplacer();
}
